import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import { Typography } from '@fiverr-private/typography';
import { translate } from '@fiverr-private/i18n-react';
import type { BadgeProps } from '../../types';
import Badge from '../Badge';

const FiverrChoiceBadge = ({
  showTooltip = true,
  tooltipPosition = 'top',
  dataTestId,
  appendTooltipToBody,
  disableTooltipFlip,
}: BadgeProps) => (
  <Badge
    showTooltip={showTooltip}
    backgroundColor="blue_1200"
    tooltipContent={translate('badges.fiverr_choice_badge.tooltip')}
    tooltipPosition={tooltipPosition}
    dataTestId={dataTestId}
    appendTooltipToBody={appendTooltipToBody}
    disableTooltipFlip={disableTooltipFlip}
  >
    <Container display="inlineFlex" gap="1">
      <Typography>Fiverr’s</Typography>
      <Typography color="green_700">Choice</Typography>
    </Container>
  </Badge>
);

FiverrChoiceBadge.displayName = 'FiverrChoiceBadge';

export default FiverrChoiceBadge;
